export default {"src":"/_next/static/media/elf_m_greenblack.708721c8.svg","height":611,"width":290,"blurWidth":0,"blurHeight":0};